import { createTheme } from '@mui/material';

export const light = createTheme({
  palette: {
    mode: 'light',
  },
});

export const dark = createTheme({
  palette: {
    mode: 'dark',
  },
});
